export const API_PATHS = {
  GET_LATEST_SCORE_BY_DOCUMENT: (document: string) => `/api/v1/scores/${encodeURIComponent(document)}`,
  GET_DOCUMENT_HAS_BEEN_QUERIED: (document: string) => `/api/v1/scores/${encodeURIComponent(document)}/exists`,
  GENERATE_SCORE_REPORT: (scoreId: string) => `/api/v1/scores/${encodeURIComponent(scoreId)}/report`,
  GET_ACTIVE_CONTRACT_BY_CLIENT: (clientId: string) => `/api/v1/credenciamento/contrato/cliente/${encodeURIComponent(clientId)}`,
  GET_CONTRACTED_PLAN: '/api/v1/credenciamento/plano/contratado',
  GET_CREDIT_OPINION: (scoreId: string) => `/api/v1/scores/${encodeURIComponent(scoreId)}/opinion`,
  GET_SCORE_USAGE: '/api/v1/scores/usage',
  GET_SCORE_BENEFIT_AVAILABILITY: '/api/v1/scores/benefit/availability',
  SCORE_SUMMARY_SERVICE_PATH: '/service.sbr',
  GET_CONSULTATION_HISTORY: (document: string) => `/api/v1/scores/${encodeURIComponent(document)}/consultations`,
  GET_CONSULTATION_DETAIL: (document: string, consultationId: string) => `/api/v1/scores/${encodeURIComponent(document)}/consultations/${consultationId}`,
  SAVE_CONSULTATION_INDICATORS_SNAPSHOT: (document: string, consultationId: string) => `/api/v1/scores/${encodeURIComponent(document)}/consultations/${consultationId}/indicators`,
};

/**
 * Liga/desliga o card do Parecer Inteligente (IA) no Resultado Score.
 *
 * Desligado nesta branch: o recurso segue implementado e coberto por testes,
 * mas nao e montado na tela — nenhuma chamada a `/opinion` e disparada.
 * Para reabilitar, basta trocar para `true` (ponto unico de controle).
 */
export const SMART_OPINION_ENABLED: boolean = true;

export const SCORE_SUMMARY_SERVICE_NAME = 'ScoreSP.getSummary';

export const SCORE_CATEGORY = 'SCORE';

export const SCORE_MAX = 1000;

export const CREDIT_LIMIT_ALERT_THRESHOLD = 60;

export const DEFAULT_PROBABILITY_LOW_MAX = 30;
export const DEFAULT_PROBABILITY_MEDIUM_MAX = 60;
